import React, {useCallback} from 'react';

import {Group, Item} from '@pb/kit-component-group';

import {NumberInput} from './number-input/number-input';

type Props = {
    disabled?: boolean,
    time: string,
    onBlur: (time: string) => void,
};
export const TimeInput = ({disabled, time, onBlur}: Props) => {
    const updateHours = useCallback((value = 0) => {
        const validatedValue = value > 23 ? 23 : value;
        const endHours = validatedValue > 9 ? validatedValue.toString() : `0${validatedValue}`;

        onBlur(`${endHours}:${time.split(':')[1]}`);
    }, [time, onBlur]);

    const updateMinutes = useCallback((value = 0) => {
        const validatedValue = value > 59 ? 59 : value;
        const startMinutes = validatedValue > 9 ? validatedValue.toString() : `0${validatedValue}`;

        onBlur(`${time.split(':')[0]}:${startMinutes}`);
    }, [time, onBlur]);

    return (
        <Group gap="none" alignItems="center">
            <Item style={{width: 70}}>
                <NumberInput
                    disabled={disabled}
                    displayedValue={time.split(':')[0]}
                    minValue={0}
                    maxValue={23}
                    value={+time.split(':')[0]}
                    onBlur={updateHours}
                />
            </Item>
            <Item style={{width: 5}}/>
            <b>:</b>
            <Item style={{width: 5}}/>
            <Item style={{width: 70}}>
                <NumberInput
                    disabled={disabled}
                    displayedValue={time.split(':')[1]}
                    minValue={0}
                    maxValue={59}
                    value={+time.split(':')[1]}
                    onBlur={updateMinutes}
                />
            </Item>
        </Group>
    );
};
